// apiConfig.ts
const localbaseURL = 'http://localhost:8000/api';
// const localbaseURL = 'http://10.202.158.43:8000/api';
const prodURl = 'https://api.eduexpertai.com/api'; // this is the URL of the backend server VPS 
const testAPIUrl = 'https://iteractivetestapi.eduexpertai.com/api'; // Test backend server for deployment

/**
 * Hostnames this bundle knows the API address for.
 *
 * Every host the app has ever been served from is here, so the build-time
 * behaviour below is unchanged for all of them. Anything NOT listed is, by
 * definition, a tenant address — a subdomain we handed out or a customer's own
 * domain — and neither existed when this bundle was built.
 */
const PLATFORM_HOSTS = [
  'localhost',
  '127.0.0.1',
  'eduexpertai.com',
  'www.eduexpertai.com',
  'api.eduexpertai.com',
  'interactivetest.eduexpertai.com',
  'iteractivetestapi.eduexpertai.com',
];

/**
 * Where the API lives for the address this page was served from.
 *
 * WHY THIS CANNOT BE A BUILD CONSTANT ANY MORE
 * --------------------------------------------
 * One bundle is served to every tenant. A customer on learn.theircollege.edu
 * gets the same JavaScript as one on eduexpertai.com, so an absolute API URL
 * compiled in would put api.eduexpertai.com in their devtools — which is the
 * one thing they are paying not to see — and would make every call cross-origin.
 *
 * On a tenant address the API is same-origin at /api, proxied there by nginx.
 * That removes the CORS preflight, the cross-site cookie, and the leak, all at
 * once.
 *
 * A known platform host keeps EXACTLY the behaviour it had before: the switch
 * below is untouched, and every host the app has ever been served from is in
 * PLATFORM_HOSTS. So this changes nothing until a tenant address exists.
 */
/**
 * True on any host this bundle was built for: the platform's own domains and
 * localhost. False on a tenant address (a customer's domain or a subdomain we
 * handed out).
 *
 * Synchronous on purpose. The branding lookup that confirms WHICH tenant is a
 * network round-trip, and the route guard must not render a platform page in
 * the meantime. See components/shared/TenantRouteGuard.tsx.
 */
export const isPlatformHost = (): boolean => {
  const host =
    typeof window !== 'undefined' ? window.location.hostname : '';
  return !host || PLATFORM_HOSTS.includes(host);
};

const getBaseURL = () => {
  if (!isPlatformHost()) {
    // A tenant address. Same-origin, so the customer's domain is the only one
    // the browser ever sees.
    return '/api';
  }

  // Check if we're in development mode
  if (import.meta.env.DEV) {
    return localbaseURL; // Local development
  }

  // Check custom environment variable for test vs production
  const apiEnv = import.meta.env.VITE_API_ENV || 'test';

  switch (apiEnv) {
    case 'local':
      return localbaseURL;
    case 'production':
    case 'prod':
      return prodURl;
    case 'test':
      return testAPIUrl;
    default:
      return testAPIUrl;
  }
};

const baseURL = getBaseURL();
export default baseURL;

// Data_Encryption: true only in production, false otherwise (local/test)
const apiEnv = import.meta.env.VITE_API_ENV || (import.meta.env.DEV ? 'local' : 'test');
/**
 * Data_Encryption is enabled only in production environment.
 * Returns true for production, false for local and test.
 */

// export const Data_Encryption = false;  // Always true for enhanced security

export const Data_Encryption = (function getEncryptionFlag() {
  return apiEnv === 'production' || apiEnv === 'prod';
})();

// // Version Management System
export const MAIN_VERSION = 1;
export const SUB_VERSION = 625;
export const BUILD_DATE = "2026-11-04 12:00:31 AM"; // Format: YYYY-MM-DD HH:mm:ss AM/PM
export const BUILD_TIMESTAMP = 1762449757000; // Unix timestamp for cache busting // Unix timestamp for cache busting

// Combined version string
export const APP_VERSION = `${MAIN_VERSION}.${SUB_VERSION}`;
export const VERSION_INFO = {
  version: APP_VERSION,
  mainVersion: MAIN_VERSION,
  subVersion: SUB_VERSION,
  buildDate: BUILD_DATE,
  buildTimestamp: BUILD_TIMESTAMP,
  environment: apiEnv
};


